// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const LAYER_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  VISIBLE: 'visible',
  DATA_VIEW_ID: 'dataViewId',
  LAYER_NAME: 'layerName',
  DESCRIPTION: 'description',
  LAYER_OPACITY: 'layer.opacity',
  LAYER_LEGEND_ENABLED: 'layer.legend.enabled',
  LAYER_LEGEND_IMAGE: 'layer.legend.image',
  COPYRIGHT: 'copyright',
  LAYER_LEGEND_IMAGE_REPOSITORY: 'layer.legend.image.repository',
  LAYER_LEGEND_IMAGE_CONTENT_IDENTIFIER: 'layer.legend.image.contentIdentifier',
  LAYER_LEGEND_IMAGE_SIGNATURE: 'layer.legend.image.signature',
  LAYER_TYPE: 'layerType',
  LAYER_RESOLUTION_MAXIMUM_VALUE: 'layer.resolution.maximumValue',
  LAYER_RESOLUTION_MAXIMUM_INCLUDED: 'layer.resolution.maximumIncluded',
  LAYER_RESOLUTION_MINIMUM_VALUE: 'layer.resolution.minimumValue',
  LAYER_RESOLUTION_MINIMUM_INCLUDED: 'layer.resolution.minimumIncluded',
  LAYER_SCALE_MINIMUM_VALUE: 'map.scaleRange.min',
  LAYER_SCALE_MAXIMUM_VALUE: 'map.scaleRange.max',
  LAYER_AUTO_ZOOM_ENABLED: 'layer.autoZoom.enabled',
  ZOOM_TO_EXTENT_ENABLED: 'layer.zoomToExtent.enabled',
  CLASSIC_TOGGLE_LAYER_ACTIVE_THEME_ID: 'activeThemeID',
  INFO_WINDOW_SHOW_DESCRIPTION: 'layer.infoWindow.showDescription',
  CLASSIC_GROUP_LAYER_ORDERING: 'groupLayerOrdering',
  CLASSIC_GROUP_LAYER_VISIBILITIES: 'groupLayerVisibilities',
  SKETCH_LAYER_REPOSITORY_NAME: 'sketchLayer.repositoryName',
  SKETCH_LAYER_CONTENT_IDENTIFIER: 'sketchLayer.contentIdentifier',
  EXTERNAL_LAYER_SERVICE_TYPE: 'externalLayer.service.type',
  EXTERNAL_LAYER_SERVICE_NAME: 'externalLayer.service.name',
  EXTERNAL_LAYER_DATASOURCE_REPOSITORY_NAME: 'externalLayer.datasource.repositoryName',
  EXTERNAL_LAYER_DATASOURCE_ID: 'externalLayer.datasource.id',
  EXTERNAL_LAYER_SERVICE_URL: 'externalLayer.service.url',
  EXTERNAL_LAYER_SERVICE_USER: 'externalLayer.service.user',
  EXTERNAL_LAYER_SERVICE_PASSWORD: 'externalLayer.service.password',
  EXTERNAL_LAYER_IDENTIFIER: 'externalLayer.identifier',
  EXTERNAL_LAYER_STYLE_NAME: 'externalLayer.styleName',
  EXTERNAL_LAYER_IMAGE_FORMAT: 'externalLayer.imageFormat',
  EXTERNAL_LAYER_CLIENT_DATA_ACCESS: 'externalLayer.client.data.access',
  EXTERNAL_LAYER_FEATURE_INFO: 'externalLayer.featureInfo',
  CATALOG_LAYER_REPOSITORY_NAME: 'catalogLayer.repositoryName',
  CATALOG_LAYER_ITEM_NAME: 'catalogLayer.itemName',
  CATALOG_LAYER_ANALYSIS_CONTEXT_ENABLED: 'catalogLayer.analysisContext.enabled',
  IS_CLASSIC_LAYER: 'isClassicLayer',
  CATALOG_LAYER_PRINT_NAME: 'catalogLayer.printName',
  CATALOG_LAYER_REFERENCED_LAYER_ID: 'catalogLayer.referencedLayerId',
  ARCGIS_LAYER_RASTER_FUNCTION: 'arcGISLayer.rasterFunction',
  DATA_VIEW_LAYER_SERVER_SIDE_RENDERING: 'dataViewLayer.serverSideRendering'
} as const;

/** @see net/disy/cadenza/workbook/model/LayerSettingsKey.java */
export type LayerSettingsKey = keyof typeof LAYER_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const LayerSettingsKey = {
  values: Object.keys(LAYER_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly LayerSettingsKey[],
  toPersistenceKey: (value: LayerSettingsKey) => LAYER_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = LayerSettingsKey.values.find(key => LAYER_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No LayerSettingsKey for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
